import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <AboutSection />
        <MediaSection />
        <FeaturesSection />
        <FaqSection />
        <IndexSection />
        <UpdatesSection />
        <CardsSection />
        <AppSection />
        <CommentsSection />
        <ContactSection />
        <TopicsSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}